import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {LocalActor} from '@acng/frontend-relativity';

import {ctxListPosition} from '../../layout/context/list-position.js';
import {LIST_POSITION} from '@acng/frontend-discovery';
import {on} from '@acng/frontend-bounty/dom/event.js';
import {debug} from '@acng/frontend-bounty/dom/debug.js';

/**
 * @group DOM Attribute
 */
export const MOVIE_PREVIEW_AUTOPLAY = 'movie-preview-autoplay';

AttributeSetup(MOVIE_PREVIEW_AUTOPLAY, (name) => {
  const provide = LocalActor(ctxListPosition);

  AttributeLink(name, () => (element) => {
    try {
      provide(element, null);
      DEBUG: if (debug(element)) console.log(`provide list position`, {element});

      on(element, LIST_POSITION, (evt) => {
        DEBUG: if (debug(element)) console.log(`[${name}]`, {evt});

        provide(element, evt);
      });
    } catch (reason) {
      DEBUG: if (debug(element)) console.debug(`list position is already provided.`, {element});
    }
  });
});
